var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mr-2",attrs:{"color":"techBlue","outlined":""},on:{"click":function($event){_vm.dialog = true}}},[_vm._v(" AI Report "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-open-in-app")])],1),_c('AiReportDialog',{model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }